<template>
  <div class="vx-row">
    <div class="vx-col sm:w-1/3 w-full flex items-center">
      <span>Warehouse</span>
    </div>
    <div class="vx-col sm:w-2/3 w-full">
      <multiselect v-model="selected" :options="options" @input="handleSelect" placeholder="Type to search"
        track-by="id" label="name" :multiple="isMultiple" :allow-empty="true">
        <span slot="noResult">Oops! No data found</span>
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title">{{ props.option.code }} {{ props.option.name }}</span>
          </span>
        </template>

        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.code }} {{ props.option.name }}</span>
          </div>
        </template>
      </multiselect>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isMultiple: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      baseUrl: "/api/sfa/v1/warehouses",
      options: [],
      selected: [],
    };
  },

  methods: {
    reset() {
      this.selected = [];
      this.options = [];
    },
    getData(params) {
      this.$vs.loading();

      this.$http.get(this.baseUrl, { params }).then((resp) => {
        if (resp.code === 200) {
          let options = [];

          // ✅ add ALL option
          options.push({
            id: 0,
            code: "",
            name: "All",
          });

          if (resp.data.records) {
            resp.data.records.forEach((item) => {
              options.push(item);
            });
          }

          this.options = options;
        } else {
          this.options = [];
        }

        this.$vs.loading.close();
      });
    },
    handleSelect(val) {
      if (!val || val.length === 0) {
        this.selected = [];
        this.$emit("data", []);
        return;
      }

      let results = Array.isArray(val) ? [...val] : [val];

      const hasAll = results.some(item => item.id === 0);

      if (hasAll && results.length > 1) {
        const lastSelected = val[val.length - 1];

        if (lastSelected.id === 0) {
          // 👉 User baru saja pilih ALL → clear others
          this.selected = [lastSelected];
          this.$emit("data", [lastSelected]);
          return;
        } else {
          // 👉 User pilih item lain saat ALL sudah ada → remove ALL
          results = results.filter(item => item.id !== 0);

          this.selected = results;
          this.$emit("data", results);
          return;
        }
      }

      this.selected = results;
      this.$emit("data", results);
    }
  },

  mounted() {
    this.getData({ length: 0 });
  }
};
</script>
